import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Button from '@mui/material/Button';
import { useMediaQuery } from '@mui/material';

const imgProjects = [
    {
        alt: 'LCAH img',
        imgUrl: '/images/capturaLCAH.png',
        projectUrl: 'https://likecampingathome.netlify.app/',
        repositoryUrl: 'https://github.com/lule1000/l-c-a-h',
        projectTitle: 'Like Camping at Home',
        projectText: 'Used tools: React, Bootstrap, Material UI, Firebase, Formik, Auth0 and so on... '
    },
    {
        alt: 'FS img',
        imgUrl: '/images/capturaFS.png',
        projectUrl: 'https://lule1000.github.io/remeras_futbol/',
        repositoryUrl: 'https://github.com/lule1000/remeras_futbol',
        projectTitle: 'Football Shirts',
        projectText: 'Used tools: HTML, CSS, JavaScript Vainilla, Bootstrap, Toastify Js and so on...'
    }
]

const Projects = () => {
    const space = useMediaQuery('(max-width:600px)')

    return (
        <div className="m-5 text-white">
            {
                space && <div className='mt-4'></div>
            }
            <h1 className="divTitle">Projects:</h1>
            <div>
                <p className="ms-2 divText">
                    These are the works I have done for CoderHouse. In each one you will find the link to where the uploaded application is and also to the repository.
                </p>
                <div className="d-flex justify-content-center flex-column flex-md-row align-items-center">
                    {
                        imgProjects.map(({ alt, imgUrl, projectUrl, repositoryUrl, projectTitle, projectText }) => (
                            <div key={alt} className="m-2 d-flex flex-column align-items-center">
                                <h3 className='divText'>{projectTitle}:</h3>
                                <p className='divText'>{projectText}</p>
                                <a target="blanck" className="pictureContainer" href={projectUrl}>
                                    <img className="w-100 rounded-2" src={imgUrl} alt={alt} />
                                </a>
                                <a target='blanck' className='m-2 text-decoration-none' href={repositoryUrl}>
                                    <Button sx={{ color: '#18ffff' }} startIcon={<RemoveRedEyeIcon />}>
                                        See Repository
                                    </Button>
                                </a>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default Projects;